import React from 'react';

const CancelarBaixaIcon = ({ size = 20, className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 25.414 25.414">
    <g id="Grupo_503" data-name="Grupo 503" transform="translate(-1273.793 -564.793)">
      <path
        id="Icon_awesome-hand-holding-usd"
        data-name="Icon awesome-hand-holding-usd"
        d="M11.427,6.892l2.218.683a.4.4,0,0,1,.271.387.39.39,0,0,1-.373.4H12.088a1.073,1.073,0,0,1-.457-.105.52.52,0,0,0-.625.1l-.776.836a.6.6,0,0,0,.067.879,3.1,3.1,0,0,0,1.411.549v.845a.741.741,0,0,0,.71.764h.71a.741.741,0,0,0,.71-.764v-.841a2.652,2.652,0,0,0,2.187-3.009,2.739,2.739,0,0,0-1.9-2.278L11.9,4.652a.4.4,0,0,1-.271-.387.39.39,0,0,1,.373-.4h1.455a1.073,1.073,0,0,1,.457.105.52.52,0,0,0,.625-.1l.776-.836a.6.6,0,0,0-.067-.879A3.1,3.1,0,0,0,13.84,1.61V.764A.741.741,0,0,0,13.13,0h-.71a.741.741,0,0,0-.71.764V1.6A2.652,2.652,0,0,0,9.524,4.614,2.739,2.739,0,0,0,11.427,6.892Zm12.256,8.779a1.263,1.263,0,0,0-1.788,0L18.027,19.2a2.474,2.474,0,0,1-1.677.669H11.4a.771.771,0,0,1,0-1.528h3.278a1.443,1.443,0,0,0,1.393-1.271,1.482,1.482,0,0,0-1.322-1.786h-6.7a4.552,4.552,0,0,0-3.1,1.256l-1.947,1.8H.67a.724.724,0,0,0-.67.764v4.585a.724.724,0,0,0,.67.764H15.614a2.49,2.49,0,0,0,1.677-.669l6.334-5.779a1.671,1.671,0,0,0,.058-2.336Z"
        transform="translate(1274.188 565)"
        fill="#fff"
      />
      <line
        id="Linha_65"
        data-name="Linha 65"
        x2="24"
        y2="24"
        transform="translate(1274.5 565.5)"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export default CancelarBaixaIcon;
